const isFieldEmpty  = (field: any): boolean => {
    if(field === undefined ||
        field === null || 
        field === "") {
            return true;
        } 
    else {
        return false;
    }
}

export default isFieldEmpty;